import { cdn } from '../../helpers/cdn';

export const chatters = {
  icon: cdn('icons/chatters.svg'),
  title: 'Top Chatters',
  colorPrimary: '#00bfe0',
  colorSecondary: '#f0fcff',
  name: 'chatters'
}

export const twitchEmotes = {
  icon: cdn('icons/twitch.svg'),
  title: 'Top Twitch Emotes',
  colorPrimary: '#9200ff',
  colorSecondary: '#f9f1ff',
  name: 'twitchEmotes'
}

export const sevenTVEmotes = {
  icon: cdn('icons/7tv_v1.svg'),
  title: 'Top 7TV Emotes',
  colorPrimary: '#29d8f6',
  colorSecondary: '#4fc2bc',
  name: 'sevenTVEmotes'
}

export const bttvEmotes = {
  icon: cdn('icons/bttv.svg'),
  title: 'Top BTTV Emotes',
  colorPrimary: '#ff5e65',
  colorSecondary: '#fff6f7',
  name: 'bttvEmotes'
}

export const ffzEmotes = {
  icon: cdn('icons/frankerfacez.png'),
  title: 'Top FFZ Emotes',
  colorPrimary: '#52d3a9',
  colorSecondary: '#f6fcfa',
  name: 'ffzEmotes'
}

export const commands = {
  icon: cdn('icons/!.png'),
  title: 'Top Commands',
  colorPrimary: '#f5a623',
  colorSecondary: '#fcf8cf',
  name: 'commands'
}

export const hashtags = {
  icon: cdn('icons/top-hashes.svg'),
  title: 'Top Hashtags',
  colorPrimary: '#b8e986',
  colorSecondary: '#fbfdf8',
  name: 'hashtags'
}



// WEBPACK FOOTER //
// ./src/app/pages/chatstats/constants.js